<template>
    <v-chip
      v-bind="statusProps"
      small
    >
        <v-icon
            v-if="isInProgress"
            small
            left
            class="progress-clock"
            :color="statusProps.dark ? 'white' : 'black'"
        >
            {{ ICONS.PROGRESS_CLOCK }}
        </v-icon>
        {{ $t(`tracks.sequence_evaluations.status_${status}`) }}
    </v-chip>
</template>

<script>
import { SequenceEvaluationStatus } from '@/constants/status';
import { ICONS } from '@/constants/icons';

export default {
    name: 'SequenceStatusChip',
    data: () => ({
        ICONS
    }),
    props: {
        status: {
            type: String,
            required: true
        },
        isInProgress: {
            type: Boolean,
            'default': false
        }
    },
    computed: {
        statusProps () {
            switch (this.status) {
            case SequenceEvaluationStatus.INTERRUPTED:
            case SequenceEvaluationStatus.IN_PROGRESS:
                return {
                    color: '#7a6d1b',
                    dark: true
                };
            case SequenceEvaluationStatus.MISSED:
                return {
                    color: '#7E4F4F',
                    dark: true
                };
            case SequenceEvaluationStatus.COMPLETED:
            case SequenceEvaluationStatus.OK:
                return {
                    color: '#2e7a1d',
                    dark: true
                };
            case SequenceEvaluationStatus.PENDING:
            case SequenceEvaluationStatus.WAITING:
                return {
                    color: '#9e9e9e',
                    dark: true
                };
            default:
                return {
                    color: '#E8EBEB'
                };
            }
        }
    }
};
</script>

<style scoped lang="scss">
    .progress-clock {
        animation-name: blink;
        animation-duration: 3s;
        animation-iteration-count: infinite;
    }

    @keyframes blink {
        0% {opacity: 1;}
        50% {opacity: 0.5;}
        100% {opacity: 1;}
    }
</style>
